module.exports = __webpack_public_path__ + "static/media/download_qr_code_cgj.5e2ab39b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/download_qr_code_cgj.png
// module id = 426
// module chunks = 0